import css from './header.module.css'
import OIGseal from '../../oig-seal.png'
import React from 'react'

const BasicHeader = ({ logo, title, subtitle }) => {
  const imgPath = logo ? logo : OIGseal

  return (
    <div className={css.basicHeader}>
      <section className="ds-l-container">
        <div className="ds-l-row">
          <div className="ds-l-col">
            <div className={css.logo} id="logo" data-testid="header-logo">
              <img src={imgPath} alt="" />
              <div className={css.logoText}>
                {title && (
                  <span
                    className={css.logoTextTitle}
                    aria-label={title}
                    data-testid="header-title"
                  >
                    {title}
                  </span>
                )}
                {subtitle && (
                  <span
                    className={css.logoTextSubtitle}
                    aria-label={subtitle}
                    data-testid="header-subtitle"
                  >
                    {subtitle}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default BasicHeader
